import React from "react";

const HTMLlogo = () => {
    return (
        <svg className="slide" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.88383 90.0036L0.859375 0H89.0343L81.0013 89.9895L44.8929 100L8.88383 90.0036Z" fill="#333333" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M44.9468 92.3484L74.1242 84.2593L80.9889 7.35913H44.9468V92.3484Z" fill="#565656" />
            <path d="M30.3399 40.7402H44.9468V51.7786H20.2446L17.2673 18.3978H44.9468V29.4365H29.3311L30.3399 40.7402Z" fill="#EBEBEB" />
            <path d="M44.8985 69.4215L44.9468 69.4086V80.8933L44.896 80.9074L22.2843 74.6303L20.7378 57.2981H31.8188L32.6047 66.1019L44.8985 69.4215Z" fill="#EBEBEB" />
            <path d="M44.9087 18.3978H72.5605L71.5721 29.4365H44.9087V18.3978Z" fill="white" />
            <path d="M44.9087 51.7786V40.7402H70.5677L70.2983 43.7044L67.5384 74.6303L44.9087 80.9021V69.4178L57.2202 66.0948L58.5015 51.7786H44.9087Z" fill="white" />
        </svg>
    )
};

export default HTMLlogo;